import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/10 last:border-0 bg-black/80 backdrop-blur-sm rounded-lg mb-2" data-id="element-25">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-4 sm:py-6 px-4 sm:px-6 text-left" data-id="element-26">
        <h3 className="text-base sm:text-lg md:text-xl font-medium text-white pr-2" data-id="element-27">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 ml-2 sm:ml-4" data-id="element-28">
          <ChevronDownIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white/70" data-id="element-29" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-30">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-31">
            <div className="pb-4 sm:pb-6 px-4 sm:px-6 text-white/70 whitespace-pre-line text-sm sm:text-lg" data-id="element-32">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};